import { Tooltip } from '@zendeskgarden/react-tooltips'
import { useMemo } from 'react'

import { usePSNavigate } from '../../hooks/usePSNavigate'
import { Item } from '../../models/Item'
import { User } from '../../models/User'
import { CalendarAvailabilityLocationState, TimeSlot } from '../../utils/calendar'
import { Icon } from '../Icon'
import Button from '../app/design/Button'
import { ContactAvatar } from '../contacts/ContactAvatar'
import { CalendarScheduleDateLabel } from './CalendarScheduleDateLabel'

type Props = {
    selectedDay: moment.Moment
    selectedTimeSlot: TimeSlot
    selectedProIds: string[]
    selectedItem: Item | null | undefined
    pros: User[]
    onEditPros: () => void
    onDelete: () => void
}

export const CalendarAvailabilityFooter = ({
    selectedDay,
    selectedTimeSlot,
    selectedProIds,
    selectedItem,
    pros,
    onEditPros,
    onDelete,
}: Props) => {
    const navigate = usePSNavigate()

    const date = useMemo(() => {
        const hour = selectedTimeSlot.start.get('hour')
        const minute = selectedTimeSlot.start.get('minute')
        return selectedDay.clone().set({ hour, minute, second: 0, millisecond: 0 }).toISOString()
    }, [selectedTimeSlot.start, selectedDay])

    const locationState: CalendarAvailabilityLocationState = useMemo(
        () => ({
            date,
            item: selectedItem,
            proIds: selectedProIds,
            duration: selectedTimeSlot.duration,
        }),
        [date, selectedItem, selectedProIds, selectedTimeSlot.duration]
    )

    return (
        <div className="absolute right-[-32px] bottom-0 left-[-32px] flex items-center gap-6 border-t-[1px] border-t-gray-300 bg-white px-8 py-4">
            <CalendarScheduleDateLabel
                date={selectedDay}
                start={selectedTimeSlot.start}
                duration={selectedTimeSlot.duration}
                selectedItem={selectedItem}
            />

            {selectedProIds.length > 0 && (
                <>
                    <Tooltip
                        content="Edit Pros"
                        size="medium"
                        style={{
                            background: '#3C94A4',
                            borderRadius: 8,
                            fontSize: 13,
                        }}
                    >
                        <div
                            className="ml-[-10px] flex h-[44px] cursor-pointer items-center first:ml-0"
                            onClick={onEditPros}
                        >
                            {pros
                                .filter((e) => !!e.id && selectedProIds.includes(e.id))
                                .map((employee) => (
                                    <ContactAvatar
                                        key={employee.id}
                                        user={employee}
                                        size="sm"
                                        style={{ border: '2px solid #20BC52' }}
                                    />
                                ))}
                        </div>
                    </Tooltip>

                    <div className="h-[44px] border-l-[1px] border-l-gray-300"></div>

                    <Button shape="square" intent="tertiary_deprecated" onClick={onDelete}>
                        <Icon icon="trash.medium" />
                    </Button>
                </>
            )}

            <Button className="ml-auto" intent="primary" onClick={() => navigate('/bookings/new')}>
                Schedule client
            </Button>
        </div>
    )
}
